import styled from "@emotion/styled";
import { DialogV2, Theme, Typography } from "@yuno/design-system-web";
import { useTranslation } from "react-i18next";

const Title = styled(Typography)(({ theme }: { theme?: Theme }) => ({
  ...theme.typography.l.bold,
  fontSize: `${theme.typography.l.bold.fontSize}!important`,
}));

const Content = styled.div`
  margin: 4px;
`;

export const DialogPublish = ({ open, onToggle, onPublish }) => {
  const { t } = useTranslation();
  return (
    <div>
      <DialogV2
        open={open}
        closeIcon={onToggle}
        title={<Title>{t("dialogTitle")}</Title>}
        buttons={[
          {
            //@ts-ignore
            variant: "tertiary",
            label: t("dialogCancel"),
            size: "small",
            event: onToggle,
          },
          {
            //@ts-ignore
            variant: "contained",
            label: t("dialogDone"),
            size: "small",
            event: () => {
              onToggle();
              onPublish();
            },
          },
        ]}
      >
        <Content>
          <Typography marginBottom={"20px"}>{t("dialogBody")}</Typography>
          <Typography>{t("dialogBody1")}</Typography>
        </Content>
      </DialogV2>
    </div>
  );
};
